var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper-Cmodulos"},[_c('h3',{staticClass:"mb-2"},[_vm._v("Modulo de Consultas")]),_vm._v(" "),_c('CMenuModulo',{attrs:{"moduloId":_vm.enumeraciones.sinoj.modulos.Consultas.id}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27741fb2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SINOJ/Consultas/CMenuConsultas.vue
// module id = null
// module chunks = 